import type { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link } from '@remix-run/react';
import type { RemixLinkProps } from '@remix-run/react/dist/components';

type Button3DProps = SxProps & {
  children: React.ReactNode;
  href: RemixLinkProps['to'];
  maxWidth?: string | number;
};

export default function Button3D({ children, href, maxWidth = 'fit-content', ...sx }: Button3DProps) {
  return (
    <Box sx={[{ position: 'relative', width: '100%', maxWidth }, sx]}>
      <Box sx={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, bgcolor: '#302F54', borderRadius: 2 }} />
      <Button
        component={Link}
        to={href}
        variant="contained"
        size="large"
        sx={{
          px: 2,
          width: '100%',
          textTransform: 'uppercase',
          transform: 'translate(4px, -4px)',
          boxShadow: 'none !important',
          borderRadius: 2,
          transition: 'transform 250ms ease',
          '&:focus-visible, &:active': {
            transform: 'translate(2px, -2px)',
          },
        }}
      >
        {children}
      </Button>
    </Box>
  );
}
